//Bootstrap accordions, toggle label
jQuery(document).ready(function () {
    jQuery('.bootstrap-collapse-toggle').click(function () {
        const $this = jQuery(this);
        const dataLabel = 'label-toggle';
        const toggleText = $this.data(dataLabel);

        if (!toggleText) {
            return;
        }

        const currentText = $this.text();

        $this.text(toggleText);
        $this.data(dataLabel, currentText);
    });
});
